import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CurrencyFormatPipe } from './currency-format.pipe';
import { FilterPipe } from './filter.pipe';
import { TempoPercorridoPipe } from './tempo-percorrido.pipe';
import { FormatarEnderecoPessoaPipe } from './formatar-endereco-pessoa.pipe';
import { DecimalFormatPipe } from './DecimalFormat.pipe';

@NgModule({
  declarations: [
    FilterPipe,
    CurrencyFormatPipe,
    TempoPercorridoPipe,
    FormatarEnderecoPessoaPipe,
    DecimalFormatPipe,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    FilterPipe,
    CurrencyFormatPipe,
    TempoPercorridoPipe,
    FormatarEnderecoPessoaPipe,
    DecimalFormatPipe,
  ]
})
export class PipesModule { }
